<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="基础分数" prop="scoreSet">
        <el-input v-model="dataForm.scoreSet" placeholder="请输入基础分数"></el-input>
      </el-form-item>
      <el-form-item label="统计类型" prop="statisticsType">
        <template>
          <el-switch
                  v-model="dataForm.statisticsType"
                  active-text="按照平均分统计" :active-value="0"
                  inactive-text="按照总分统计" :inactive-value="1" inactive-color="#13ce66">
          </el-switch>
        </template>
      </el-form-item>
      <el-form-item label="评分是否关联学生" prop="isRelationStudent" size="mini">
        <el-radio-group v-model="dataForm.isRelationStudent">
          <el-radio :label="0" >否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="优秀班级类型" prop="evaluateType">
        <template>
          <el-radio-group v-model="dataForm.evaluateType">
            <el-radio :label="0">无</el-radio>
            <el-radio :label="1">流动红旗</el-radio>
            <el-radio :label="2">五星班级</el-radio>
            <el-radio :label="3">优胜班级</el-radio>
          </el-radio-group>
        </template>
      </el-form-item>
      <el-form-item label="申诉管理员通知" prop="isAppealMessage" size="mini">
        <el-radio-group v-model="dataForm.isAppealMessage">
          <el-radio :label="0" >否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否即评即撤销" prop="rollBack" size="mini">
        <el-radio-group v-model="dataForm.rollBack">
          <el-radio :label="0" >否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="大屏端是否允许查看其他班级" prop="isOtherClass" size="mini">
        <el-radio-group v-model="dataForm.isOtherClass">
          <el-radio :label="0" >否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="可申述时间范围" prop="teacherAppealTime" size="mini">
        <el-radio-group v-model="dataForm.teacherAppealTime">
          <el-radio :label="1" >一周内</el-radio>
          <el-radio :label="0">不设限</el-radio>
        </el-radio-group>
      </el-form-item>
<!--      <el-form-item label="是否允许完成以往争章任务" prop="isContinue" size="mini">-->
<!--        <el-radio-group v-model="dataForm.isContinue">-->
<!--          <el-radio :label="0" >否</el-radio>-->
<!--          <el-radio :label="1">是</el-radio>-->
<!--        </el-radio-group>-->
<!--      </el-form-item>-->
      <el-form-item label="学校" prop="schoolId" v-if="schoolVisible">
        <el-select v-model="dataForm.schoolId" placeholder="请选择学校" clearable>
          <el-option v-for="school in schoolList" :label="school.schoolName" :value="school.id"
                     :key="school.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      schoolVisible: false,
      schoolList: [],
      dataForm: {
        id: '',
        scoreSet: '',
        isRelationStudent: 0,
        statisticsType: 1,
        evaluateType: 0,
        createDate: '',
        schoolId: '',
        isAppealMessage: 0,
        teacherAppealTime: 0
      }
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {




      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/classEvaluate/evaluateRule/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    resetValue () {
      this.dataForm.schoolId = ''
      this.schoolVisible = false
    },
    // 获取学校的集合
    getSchoolList () {
      this.$http.get('/school/school/getSchoolList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.schoolList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        // 正整数的正则表达式
        // const r = /^\+?[1-9][0-9]*$/
        // 如果判断不符合正则，则不是正整数不能提交
        // if (!r.test(this.dataForm.scoreSet))
        //   return this.$message.error('数量必须为正整数')
        // }
        // 一位小数的正则表达式
        const r = /^[+-]?(0|([1-9]\d*))(\.\d{1})?$/
        if (!r.test(this.dataForm.scoreSet)) {
          return this.$message.error('最多支持小数点后一位')
        }
        this.$http[!this.dataForm.id ? 'post' : 'put'](`/classEvaluate/evaluateRule?schoolId=${this.dataForm.schoolId}`, this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            if (res.code === 10050) {
              this.schoolVisible = true
              this.getSchoolList()
            }
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
